import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-right-panel-2-icon',
  templateUrl: './layout-layout-right-panel-2.component.html'
})
export class LayoutLayoutRightPanel2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
